import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FullComponent } from './layouts/full/full.component';
import { LoginComponent } from './login/login.component';
import { LoginEstudianteComponent } from './modules/estudiante/login-estudiante/login-estudiante.component';
import { LoginDsaComponent } from './login/loginDSA/login-dsa.component';
import { LoginPostulanteComponent } from './login/loginPostulante/login-postulante.component';
import { CambioCredencialPostulanteComponent } from './login/loginPostulante/cambio-credencial-postulante/cambio-credencial-postulante.component';


import { PermisosValidateGuard } from "./guards/permisos-validate.guard";
import { NotFoundComponent } from "./not-found/not-found.component";
import { FichaAdmisionComponent } from './public/ficha-admision/ficha-admision.component';
import { HomePageComponent } from './public/home-page/home-page.component';
import { OfertaAcademicaComponent } from './public/oferta-academica/oferta-academica.component';
import { CambioCredencialComponent } from './modules/estudiante/cambio-credencial/cambio-credencial.component';
import { ValidarDocumentoComponent } from './public/validar-documento/validar-documento.component';

const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent, 
    data: { title: 'Login' }
  },
  {
    path: 'estudiante/login',
    component: LoginEstudianteComponent,
    data: { title: 'Login' }
  },
  {
    path: 'dsa/login',
    component: LoginDsaComponent,
    data: { title: 'Login' }
  },
  {
    path: 'postulante/login',
    component: LoginPostulanteComponent,
    data: { title: 'Login' }
  },
  {
    path: 'postulante/cambioCredencial',
    component: CambioCredencialPostulanteComponent,
    data: { title: 'CambioCredencialPostulanteComponent' }
  },
  {
    path: 'fichaAdmision/:idCentro/:idPosgrado/:eleccion',
    component: FichaAdmisionComponent,
    data: { title: 'Ficha Admision' }
  },
  {
    path: 'inicio',
    component: HomePageComponent,
    data: { title: 'Inicio' }
  },
  {
    path: 'ofertaAcademica',
    component: OfertaAcademicaComponent,
    data: { title: 'Oferta Academica' }
  },
  {
    path: 'CambioCredencial',
    component: CambioCredencialComponent,
    data: { title: 'CambioCredencialComponent' }
  },
  {
    path: 'validar/:docId',
    component: ValidarDocumentoComponent,
    data: { title: 'Verificar Documento' }
  },
  {
    path: 'validar',
    component: ValidarDocumentoComponent,
    data: { title: 'Verificar Documento' }
  },
  {
    path: '',
    component: FullComponent,
    canActivateChild: [PermisosValidateGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'seguridad',
        loadChildren: () => import('./pages/Seguridad/seguridad.module').then(m => m.SeguridadModule)
      },
      {
        path: 'solicitudes',
        loadChildren: () => import('./modules/solicitudes/solicitudes.module').then(m => m.SolicitudesModule)
      },
      {
        path: 'programacion-academica',
        loadChildren: () => import('./modules/programacion-academica/programacion-academica.module').then(m => m.ProgramacionAcademicaModule)
      },
      {
        path: 'dictamen',
        loadChildren: () => import('./modules/dictamen/dictamen.module').then(m => m.DictamenModule)
      },
      {
        path: 'estudiante',
        loadChildren: () => import('./modules/estudiante/estudiante.module').then(m => m.EstudianteModule)
      },
      {
        path: 'coordinador',
        loadChildren: () => import('./modules/coordinador/coordinador.module').then(m => m.CoordinadorModule)
      },
      {
        path: 'docente',
        loadChildren: () => import('./modules/docente/docente.module').then(m => m.DocenteModule)
      },
      {
        path: 'dipp',
        loadChildren: () => import('./modules/dipp/dipp.module').then(m => m.DippModule)
      },
      {
        path: 'consultas',
        loadChildren: () => import('./modules/consultas/consultas.module').then(m => m.ConsultasModule)
      },
      {
        path: 'postulacion',
        loadChildren: () => import('./modules/postulacion/postulacion.module').then(m => m.PostulacionModule)
      },
      {
        path: 'comisiones',
        loadChildren: () => import('./modules/comisiones/comisiones.module').then(m => m.ComisionesModule)
      },
      {
        path: 'proceso-admision',
        loadChildren: () => import('./modules/proceso-admision/proceso-admision.module').then(m => m.ProcesoAdmisionModule)
      }
    ]
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' },

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]

})

export class ApppRoutingModule{}
